{
  "Add a new card": "Ajoutez une nouvelle carte",
  "Add a new ACH account": "Ajoutez un nouveau compte ACH",
  "Bank": "Banque",
  "Visa": "Visa",
  "Mastercard": "Mastercard",
  "Discover": "Découvrir",
  "Amerian Express": "American Express",
  "Auto-Pay On": "Paiement Automatique Activé",
  "Auto-Pay Off": "Paiement Automatique Désactivé",
  "Payment Method Missing": "Méthode de Paiement Manquante",
  "Home": "Accueil",
  "Reserve": "Réservez",
  "Menu & Events": "Menu & Événements",
  "Billing": "Facturation",
  "Sign Out": "Se déconnecter",
  "Issued Date": "Date d'émission",
  "Invoice Number": "Numéro de Facture",
  "Description": "Description",
  "Invoice Payment Amount": "Montant du Paiement de la Facture",
  "Due Date": "Date d'échéance",
  "Status": "Statut",
  "invoiceEmptyState": "Vous n'avez actuellement aucune facture impayée ici.",
  "Payment Due": "Paiement dû",
  "Late": "Tard",
  "Paid": "Payé",
  "Processing": "Traitement",
  "Failed": "Échoué",
  "Voided": "Annulé",
  "Member Benefits": "Avantages des Membres",
  "Meeting Room": "Salle de Réunion",
  "Office": "Bureau",
  "Desk": "Bureau",
  "Open Workspace": "Espace de Travail Ouvert",
  "New": "Nouveau",
  "Your Profile": "Votre Profil",
  "Company Profile": "Profil de l'entreprise",
  "Member Management": "Gestion des Membres",
  "FAQ": "FAQ",
  "Notification Settings": "Paramètres de notification",
  "Refer a Friend": "Parrainez un ami",
  "beta": "bêta",
  "Something Went Wrong": "Quelque Chose S'est Mal Passé",
  "Page Not Found": "Page Non Trouvée",
  "Please refresh the page and try again.": "Veuillez rafraîchir la page et réessayer.",
  "Please try our home page.": "Veuillez essayer notre page d'accueil.",
  "Refresh": "Rafraîchir"
}
